module.exports = __webpack_public_path__ + "static/img/about-1-Overview-img-2.a23f6fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-1-Overview-img-2.jpg
// module id = OBm4
// module chunks = 0